<template>
  <div class="mt-6 container has-text-centered">
    <div class="column is-4 is-offset-4">
      <img src="/img/logo.svg" />
      <hr class="login-hr" />
      <p class="subtitle has-text-black">{{ $t("auth.confirmTitle") }}</p>
      <div class="notification is-info is-light">
        {{ $t("auth.confirmMessage") }}
      </div>

      <div class="box">
        <form @submit.prevent="confirmSignUp">
          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="email"
                placeholder="Your Email"
                required
                autofocus=""
                v-model="form.email"
              />
            </div>
          </div>

          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="text"
                placeholder="Your verification code"
                required
                autofocus=""
                v-model="form.code"
              />
            </div>
          </div>

          <button
            class="button is-block is-primary is-fullwidth is-large"
            v-bind:class="{ 'is-loading': isLoad }"
          >
            {{ $t("auth.confirm") }}
          </button>
        </form>
      </div>
      <div v-if="errorMessage" class="notification is-info is-light">
        {{ errorMessage }}
      </div>
      <p class="has-text-grey mt-3">
        <a heaf="#" @click="resendConfirmationCode()">
          {{ $t("auth.reSendTitle") }}
        </a>
      </p>
      <p class="has-text-grey mt-4">
        <router-link :to="{ name: 'authSignIn' }">
          {{ $t("auth.signIn") }}
        </router-link>
        &nbsp;·&nbsp;
        <router-link :to="{ name: 'authSignUp' }">
          {{ $t("auth.signUp") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import imsr from "@/imsr-api";

export default {
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const errorMessage = ref();
    const isLoad = ref(false);
    const form = reactive({
      email: store.getters.userId,
      code: "",
    });

    const confirmSignUp = async () => {
      try {
        isLoad.value = true;
        // await Auth.confirmSignUp(form.email, form.code);
        const res = await imsr.confirmSignUp({
          email: form.email,
          confirmationCode: form.code,
        });
        store.commit("setMessage", t("auth.confirmed"));
        if (res == "success") {
          router.push({ name: "authSignIn" });
        } else if (res == "LimitExceededException") {
          errorMessage.value = t("auth.confirmLimitExceeded");
        } else {
          errorMessage.value = t("auth.confirmError");
        }
        // router.push({ name: "authSignIn" });
      } catch (e) {
        errorMessage.value = t("auth.confirmError");
      } finally {
        isLoad.value = false;
      }
    };

    const resendConfirmationCode = async () => {
      try {
        await Auth.resendSignUp(form.email);
        errorMessage.value = t("auth.reSendDone");
      } catch (e) {
        errorMessage.value = t("auth.reSendError");
        router.push({ name: "authSignIn" });
      }
    };

    return {
      form,
      errorMessage,
      isLoad,
      confirmSignUp,
      resendConfirmationCode,
    };
  },
};
</script>
